// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1YwBu","choiceBoxes":"toolbarselects_choiceBoxes__4Iz6v","simpleField":"toolbarselects_simpleField__33CGF"};